import React from 'react';
import {View} from 'react-native';
import {observer} from 'mobx-react-lite';

import RewardsProgramImage from '../../components/rewards/ProgramImage';
import Button from '../../components/themed/Button';
import KeyboardAwareScrollView from '../../components/themed/KeyboardAwareScrollView';
import Text from '../../components/themed/Text';
import ContentView from '../../components/ui-controls/layout/ContentView';
import config from '../../config';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import {useStores} from '../../stores/use-stores';
import {rewardsMarketingName} from '../../utils/rewards';

const RewardsRedirectScreen = observer(
  ({navigation}: RouteNavigatorScreenProps<AppRoute.REWARDS_REDIRECT>) => {
    const {userStore} = useStores();

    const handleGoHome = () => {
      navigation.navigate(
        AppRoute.ROOT as never,
        {
          screen: AppRoute.MAIN,
          params: {screen: AppRoute.HOME},
        } as never,
      );
    };

    const handleGoToRewards = () => {
      if (userStore.isLoggedIn) {
        // DIS-1094: User is already logged in — go directly to the card screen.
        navigation.navigate(
          AppRoute.ROOT as never,
          {
            screen: AppRoute.MAIN,
            params: {screen: AppRoute.ACCOUNT_REWARDS},
          } as never,
        );
      } else {
        // DIS-1094: User is NOT logged in — send them to login first.
        // After login, initialiseUserDataNonBlocking loads rewards data,
        // then afterLogin() navigates them directly to the card screen.
        userStore.setPostLoginReturnToScreen(
          AppRoute.ROOT as never,
          {screen: AppRoute.MAIN, params: {screen: AppRoute.ACCOUNT_REWARDS}} as never,
        );
        navigation.navigate(
          AppRoute.ROOT as never,
          {
            screen: AppRoute.MAIN,
            params: {screen: AppRoute.ACCOUNT_NOT_LOGGED_IN},
          } as never,
        );
      }
    };

    return (
      <KeyboardAwareScrollView
        style={{flex: 1}}
        contentContainerStyle={{flex: 1}}
        keyboardShouldPersistTaps="always">
        <ContentView parentStyle={{flex: 1, paddingBottom: 16}} style={{flex: 1}}>
          <RewardsProgramImage variant="onLight" />

          <View>
            <Text variant="heading1">YOU&apos;RE ALREADY A MEMBER!</Text>
          </View>
          <Text>
            It looks like this mobile number is already registered with {config.APP_NAME}&apos;s{' '}
            {rewardsMarketingName} program.
            {'\n\n'}
            {userStore.isLoggedIn
              ? 'You can access your rewards from the Rewards tab, or head back to the home screen.'
              : 'Log in to view your membership card and access your rewards.'}
          </Text>

          <View style={{gap: 8, marginTop: 40}}>
            <Button
              title={userStore.isLoggedIn ? 'GO TO REWARDS' : 'LOG IN'}
              onPress={handleGoToRewards}
            />
            <Button secondary title={'GO TO HOME'} onPress={handleGoHome} />
          </View>
        </ContentView>
      </KeyboardAwareScrollView>
    );
  },
);

export default RewardsRedirectScreen;
